import { useState, useRef, useEffect } from "react";
import { Settings } from "lucide-react";

const PREF_KEY = "ihtp-media-quality";

export function getSavedQuality() {
  if (typeof window === "undefined") return "auto";
  return window.localStorage.getItem(PREF_KEY) || "auto";
}

export default function QualitySelector({ qualities, current, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  if (!qualities || qualities.length === 0) return null;

  const options = [{ label: "auto", height: 0 }, ...qualities].sort((a, b) => b.height - a.height);

  return (
    <div ref={ref} className="absolute top-4 right-4 z-30" data-testid="media-quality-selector">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-black/60 backdrop-blur border border-white/10 text-xs hover:bg-black/80 transition"
        data-testid="media-quality-btn"
      >
        <Settings size={12} />
        <span className="uppercase tracking-wider font-semibold text-[#D1CFC9]">
          {current === "auto" ? "AUTO" : current.toUpperCase()}
        </span>
      </button>
      {open && (
        <div className="absolute top-full right-0 mt-2 min-w-[150px] glass-panel rounded-xl p-1" data-testid="media-quality-menu">
          <p className="px-3 py-2 text-[10px] uppercase tracking-widest text-slate-500 font-bold">Qualidade</p>
          {options.map((o) => {
            const val = o.label === "auto" ? "auto" : o.label;
            const isActive = current === val;
            return (
              <button
                key={val}
                onClick={() => { onChange(val); setOpen(false); }}
                className={`w-full flex items-center justify-between px-3 py-2 rounded-lg text-sm hover:bg-white/10 ${
                  isActive ? "text-[#D1CFC9]" : "text-slate-300"
                }`}
                data-testid={`media-quality-opt-${val}`}
              >
                <span>
                  {o.label === "auto" ? "Automático" : o.label.toUpperCase()}
                  {val === "720p" && <span className="text-[10px] ml-1.5 bg-[#D1CFC9]/20 text-[#D1CFC9] px-1.5 py-0.5 rounded font-semibold">HD</span>}
                </span>
                {isActive && <span className="text-[#D1CFC9]">✓</span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export function resolveQualityUrl(qualities, preference, defaultUrl) {
  if (!qualities || qualities.length === 0 || preference === "auto") return defaultUrl;
  const match = qualities.find((q) => q.label === preference);
  return match ? match.url : defaultUrl;
}

export function saveQuality(q) {
  try { window.localStorage.setItem(PREF_KEY, q); } catch {}
}
